/**
 * Serialize a flat params object into a URL query string.
 *
 * Uses URLSearchParams under the hood — array values are converted to
 * comma-separated strings via `.toString()`, matching the backend's
 * expected format.
 *
 * @param {Object} data  Key-value pairs to serialize
 * @returns {string} Encoded query string (without leading `?`)
 */
export const toUrlParams = (data) => {
  const searchParams = new URLSearchParams()

  Object.keys(data).forEach((key) => searchParams.append(key, data[key]))

  return searchParams.toString()
}

